import { create } from "zustand";
import {
  createJSONStorage,
  persist,
} from "zustand/middleware";

function extractPermissions(user) {
  const source =
    user?.role?.permissions ??
    user?.permissions ??
    [];

  return source
    .map((permission) =>
      typeof permission === "string"
        ? permission
        : permission?.name,
    )
    .filter(Boolean);
}

export const useAuthStore = create(
  persist(
    (set) => ({
      user: null,
      token: null,
      permissions: [],

      signIn: ({ user, token }) => {
        set({
          user,
          token,
          permissions: extractPermissions(user),
        });
      },

      setAuthenticatedUser: (user) => {
        set({
          user,
          permissions: extractPermissions(user),
        });
      },

      updateUser: (user) => {
        set({
          user,
          permissions: extractPermissions(user),
        });
      },

      signOut: () => {
        set({
          user: null,
          token: null,
          permissions: [],
        });
      },
    }),
    {
      name: "spend2connect-session",

      storage: createJSONStorage(
        () => localStorage,
      ),

      partialize: (state) => ({
        user: state.user,
        token: state.token,
        permissions: state.permissions,
      }),
    },
  ),
);